import React from "react";
import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { range } from "lodash-es";
import { useFormContext } from "react-hook-form";
import { ImageUploader } from "components";
import { FormValues, IMAGE_HEIGHT } from "../../duck";
import { RADIOGRAPHIC_FINDINGS_COUNT } from "./duck";

const RadiographicFindings: React.FC = () => {
  const { watch, setValue } = useFormContext<FormValues>();
  const radiographicFindings = watch("radiographicFindingsPhotos");

  return (
    <Flex direction="column" rowGap="4">
      <Text fontWeight="semibold" color="gray.600">
        Radiographic Findings
      </Text>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={4}>
        {range(RADIOGRAPHIC_FINDINGS_COUNT).map(photoIndex => (
          <ImageUploader
            key={photoIndex}
            value={radiographicFindings[photoIndex]}
            onChange={file => {
              if (!file) {
                return;
              }
              const newValue = [...radiographicFindings];
              newValue[photoIndex] = file;
              setValue("radiographicFindingsPhotos", newValue.filter(Boolean));
            }}
            enableZoom
            boxProps={{ h: IMAGE_HEIGHT }}
            stretch
          />
        ))}
      </SimpleGrid>
    </Flex>
  );
};

export default RadiographicFindings;
